<template>
  <v-container>
  <v-row class="my-4"  v-if="successBestellung">
      <v-col  cols="8">
        <h2>
         Wir haben Ihren Wunschzettel gespeichert.
        </h2>
       <p>Wir versuchen so viel Wünsche wie möglich zu erfüllen.</p>
      </v-col>
    </v-row>
    <v-row class="my-4" v-if="userData">
      <v-col cols="12" md="8" class="pr-8"> 
        <div v-if="!successBestellung">
        <h2>Ihr Waizmann`s Webinar Wunschzettel</h2>
        Wir arbeiten an einer neuen <b>kostenlosen Webinar-Reihe</b> für TeamWaizmann Zahnärzte und ZFA.  Welches Webinar wünschen Sie sich? Was sind aktuell die "betriebswirtschaftlichen" Themen, die Sie am meisten interessieren? 
        Füllen Sie jetzt kurz Ihren Waizmann`s Webinar Wunschzettel aus. Wir versuchen Ihr Wunschwebinar auf die Beine zu stellen.
        <br><br>
        <v-textarea
          v-model="wunschzettel.wun_text"
          label="Ihre Wunschthemen sind..."
          placeholder="Ihre Wunschthemen"
          rows="10"
        ></v-textarea>
        <v-textarea
          v-model="wunschzettel.wun_person"
          label="Haben Sie einen Wunsch-Referenten?"
          placeholder="Welche Referent hat Sie persönlich am meisten beeindruckt?"
          rows="3"
        ></v-textarea>

        <v-btn color="primary" @click="saveWunschzettel">jetzt Wunschzettel speichern</v-btn>
        </div>
      </v-col>

      <v-col cols="12" md="4"  >
        <span v-if="baseStore.isDesktop">
      
        <h2>TeamWaizmann Webinare</h2>
        <v-row>
          <v-col cols="12">
       Unsere letzten Webinarthemen:
       </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <ul style="padding-left: 0;">
              <li class="mb-2">Bye Bye Bema | > 350 Teilnehmer</li>
              <li class="mb-2">Profit Booster PZR | > 250 Teilnehmer</li>
              <li class="mb-2">Recruting via Social Media | > 300 Teilnehmer</li>
            </ul>
          </v-col>
        </v-row>
        <br>
      </span>
        <div v-if="!successWaizmannTabelle"  class="pa-2">
        <h3>Jetzt noch neue<br>WaizmannTabelle anfordern</h3>
        <p>Einfach anlicken und Ihre WaizmannTabelle anfordern</p>
        <v-row class="mt-2" >
          <v-col cols="2"  >
            <v-checkbox
              v-model="checkboxStates[0]"
              class="ma-0"
              @click="addOderEntferneProdukt('Waizmanntabelle ToGo', 'tabelle')"
            ></v-checkbox>
          </v-col>
         
          <v-col cols="7">
            <h4>
              <span style="color: #3166a5">
                WaizmannTabelle ToGo | Erwachsene & Kinder
                <sup class="text-green">Tipp</sup>
              </span>
            </h4>
          </v-col>
          <v-col cols="3"  >
            <img
              :src="require('@/assets/bestellung/dreifachaufsteller.jpg')"
              style="width: 80px; float: left"
            />
          </v-col>
        </v-row>
        <v-row class="my-4">
          <v-col cols="2" class="my-0 py-0 align-self-start">
            <v-checkbox
              v-model="checkboxStates[2]"
              class="ma-0"
              @click="addOderEntferneProdukt(PRODUCT_KEYS.STAND_TRIPLE, 'tabelle')"
            ></v-checkbox>
          </v-col>
          <v-col cols="7">
            <h4>
              <span style="color: #3166a5">
                3-fach Design-Aufsteller für WaizmannTabellen
              </span>
            </h4>
          </v-col>
          <v-col cols="3">
          </v-col>
        </v-row>
    <v-row class="my-4">
      <v-col cols="12" md="12">
        <v-btn color="primary" @click="startNeueBestellung">
    <v-icon>play_arrow</v-icon>
   hier klicken und kostenlos anfordern
  </v-btn>
      </v-col>
    </v-row>
    </div>
      </v-col>
    </v-row>
  </v-container>  
</template>

<script setup>
import { PRODUCT_KEYS } from '@/constants/bestellProdukte'
import { inject, onMounted,ref, reactive } from 'vue'
const updateDocumentHead = inject('updateDocumentHead');
import { storeToRefs } from 'pinia'


const baseCalls = inject('baseCalls')
const loaderStore = inject('loaderStore');
const userStore = inject('userStore');
const route = useRoute();
import { useRoute } from 'vue-router'
const successStore = inject('successStore');
const errorStore = inject('errorStore');
const { userData } = storeToRefs(userStore)
const baseStore = inject('baseStore')
const successBestellung = ref(false);
const successWaizmannTabelle = ref(false);
const checkboxStates = ref([false, false, false]); // Beispiel für drei Checkboxen
const wunschzettel = ref({
    wun_text: "",
    wun_person: "",
    action: 'saveWunschzettel',

  });

  const bestellung = reactive({
    bestell_status: 0,
    bestell_comment: "",
    bestell_produkt_text: "",
    bestell_kategorie: 0,
    action: 'neueBestellung',

  });

function addOderEntferneProdukt(titel, was) {
    if (was == "webinar") {
      bestellung.bestell_kategorie = 1;
    } else if (was == "tabelle") {
      bestellung.bestell_kategorie = 0;
    }

    if (bestellung.bestell_produkt_text) {
      if (bestellung.bestell_produkt_text.includes(titel)) {
        // Entfernt den Titel, wenn er bereits vorhanden ist
        let produkte = bestellung.bestell_produkt_text.split(", ");
        let index = produkte.indexOf(titel);
        if (index !== -1) {
          produkte.splice(index, 1); // Entfernt den Titel
          bestellung.bestell_produkt_text = produkte.join(", ");
        }
      } else {
        // Fügt den Titel hinzu, wenn er noch nicht vorhanden ist
        bestellung.bestell_produkt_text += `, ${titel}`;
      }
    } else {
      // Setzt den Titel, wenn bestell_produkt_text noch leer ist
      bestellung.bestell_produkt_text = titel;
    }

    console.log(bestellung.bestell_produkt_text);
  }


async function startNeueBestellung()
{
  loaderStore.setLoader(true)
  const response = await baseCalls.bestellungPost(bestellung)
  if (response.data.success) {
    successWaizmannTabelle.value = true;
    loaderStore.setLoader(false)
    successStore.setSuccess(true,'Ihre Bestellung wurde erfolgreich gespeichert','Ihre Bestellung wird in Kürze bearbeitet.')
    bestellung.bestell_produkt_text = '';
    bestellung.bestell_comment = '';

  } else {
    loaderStore.setLoader(false)
    errorStore.setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.')
  }
}

async function saveWunschzettel() {
  try {
    const response = await baseCalls.userPost(wunschzettel.value);
    if (response.data.success) {
      successStore.setSuccess(true,'Ihre Wunschzettel wurden gespeichert','')
      wunschzettel.value.wun_text = '';
      wunschzettel.value.wun_person = '';
      successBestellung.value = true;
    } else {
      errorStore.setError('Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.')
    }
   
  } catch (err) {
    console.error('API-Fehler:', err);
  }
  

}

async function startLogin() {
  const data = { action: 'startlogin',token: route.params.token }
  //console.log(data);
  loaderStore.setLoader(true, "Wunschzettel wird geladen...");
  try {
    const response = await baseCalls.userPost(data);
    if (response.data.user ) {
      console.log('Benutzerdaten geladen:', response.data);
      userStore.setUser(response.data.user)
      loaderStore.setLoader(false);
    } 
  } catch (err) {
   
 
    console.error('API-Fehler:', err);
  } finally {

    loaderStore.setLoader(false);
  }
}

onMounted(() => {
  if (!userData.value && route.params.token != null) {
    startLogin();
  }
  updateDocumentHead(
      'Waizmann`s Webinar  Wunschzettel',
      'Waizmann`s Webinar  Wunschzettel'
    ) 
});

  //import { reactive, ref } from "vue";
</script>
